import React from 'react'
import { MediaQueryProvider } from './src/hooks/useMediaQuery'
import { LocationProvider } from './src/hooks/useLocation'
import { AmplitudeProvider } from './src/AmplitudeProvider'
import { AmplitudeExperimentProvider  } from './src/AmplitudeExperimentProvider'
import { AmplitudeEngagementProvider  } from './src/engagement/AmplitudeEngagementProvider'

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), 600)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), 600)
  }
  return false
}

export const wrapPageElement = ({ element, props }) => {
    return (
      <>
        <MediaQueryProvider {...props}>
          <LocationProvider>
            <AmplitudeProvider>
              <AmplitudeExperimentProvider>
                <AmplitudeEngagementProvider>
                    {element}
                </AmplitudeEngagementProvider>
              </AmplitudeExperimentProvider>
            </AmplitudeProvider>
            </LocationProvider>
        </MediaQueryProvider>
      </>
    )
}